<template>
  <div class="main">
    <div class="search-box">

      <div class="search">
        <div class="search-type">
          会议预约方式:
        </div>
        <el-select v-model="type" placeholder="请选择" @change="queryMeeting">
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search">
        <div class="search-nickname">
          预约用户:
        </div>
        <el-input placeholder="请输入" prefix-icon="el-icon-search" v-model="nickname" clearable @clear="queryMeeting">
        </el-input>
        <el-button @click="queryMeeting">搜索</el-button>
      </div>
      <div class="search">
        <div class="search-initiatorName">
          发起人:
        </div>
        <el-input placeholder="请输入" prefix-icon="el-icon-search" v-model="initiatorName" clearable @clear="queryMeeting">
        </el-input>
        <el-button @click="queryMeeting">搜索</el-button>
      </div>
      <div class="search">
        <div class="search-phone">
          预约人电话:
        </div>
        <el-input placeholder="请输入" prefix-icon="el-icon-search" v-model="phone" clearable @clear="queryMeeting">
        </el-input>
        <el-button @click="queryMeeting">搜索</el-button>
      </div>
      <div class="search">
        <div class="search-phone">
          会议室名称:
        </div>
        <el-input placeholder="请输入" prefix-icon="el-icon-search" v-model="roomName" clearable @clear="queryMeeting">
        </el-input>
        <el-button @click="queryMeeting">搜索</el-button>
      </div>
    </div>
    <div class="result">
      <el-table :data="tableData" border style="width: 100%" stripe>

        <el-table-column prop="type" label="会议预约方式" align="center">
          <template slot-scope="scope"> {{ typeList.find(x => x.value == scope.row.type).label }}</template>
        </el-table-column>
        <el-table-column prop="nickname" label="预约用户" align="center">
        </el-table-column>
        <el-table-column prop="initiatorName" label="发起人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="预约人电话" align="center">
        </el-table-column>
        <el-table-column prop="roomName" label="会议室名称" align="center">
        </el-table-column>

      </el-table>
    </div>
    <div class="block">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next, jumper" :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      pageTotal: 0,
      type: "",
      typeList: [
        {
          value: 1,
          label: "PC后台预约",
        },
        {
          value: 2,
          label: "微信小程序预约",
        },
        {
          value: 3,
          label: "安卓端预约",
        },
      ],
      nickname: "",
      initiatorName: "",
      phone: "",
      roomName: "",
      tableData: [],
    };
  },
  
  methods: {
      //查询会议
      queryMeeting() {
        this.$axios
          .get(
            "https://meeting.joncloudapp.com/api/meeting/reservation/search?pageNum=" +
              this.pageNum +
              "&pageSize=" +
              this.pageSize +
              "&initiatorName=" +
              this.initiatorName +
              "&nickname=" +
              this.nickname +
              "&phone=" +
              this.phone +
              "&roomName=" +
              this.roomName +
              "&type=" +
              this.type
          )
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: res.data.message,
              });
              this.tableData = res.data.data.rows;
              this.pageTotal = res.data.data.total;
            }
            if (res.data.code == 500) {
              this.$message.error(res.data.message);
            }
          });
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.queryMeeting();
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.queryMeeting();
        console.log(`当前页: ${val}`);
      },
  },
  created(){
    this.queryMeeting()
  },
};
</script>
<style>
el-input {
  background-color: #fff;
}
body {
  box-sizing: border-box;
  /* margin:0; padding:0; */
  /* overflow-y: hidden; */
}
.input1 .el-input__inner {
  width: 335px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  padding: 0;
  background: #fff;
}
.input2 .el-input__inner {
  width: 335px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  padding: 0;
  margin-bottom: 38px;
}
</style>

<style scoped lang="scss">
.main {
  .search-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 50px 10px;
    .search {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 550;
      .search-type {
        width: 110px;
        min-width: 110px;
      }
      .search-nickname {
        width: 70px;
        min-width: 70px;
      }
      .search-initiatorName {
        width: 60px;
        min-width: 60px;
      }
      .search-phone {
        width: 90px;
        min-width: 90px;
      }
      .el-input {
        margin: 0 10px;

        .el-input__innerel-input {
          width: 100px;
        }
      }
      .el-button {
        padding: 12px 7px;
      }
    }
  }
  .result {
    padding: 50px;
    text-align: center;
  }
  .block {
    text-align: center;
  }
}
</style>